import {tryGeneratePath} from "../../../routing/routing.utils.ts";
import {ListItem, ListItemButton} from "@mui/material";
import React from "react";
import {useStores} from "../../../stores";
import {useParams} from "react-router";
import MithraMainLogo from '../../icons/logo/MithraMainLogo.svg?react';
import type {RouteKey} from "../../../routing/routes.ts";
import {MLink} from "../../_tiny/MLink.tsx";

type Props = {
    collapsed?: boolean
    route?: RouteKey
}
export const DrawerMainLogo: React.FC<Props> = ({collapsed, route}) => {
    const {p, bagStore} = useStores();
    const params = useParams();
    const path = tryGeneratePath(params, route ?? 'homepage_dashboard', bagStore.bag?.id);

    return <ListItem disablePadding className={'main-logo-menu-item ' + (collapsed ? 'collapsed' : '')}>
        <ListItemButton>
            <MLink path={path} className="mithra-logo-wrapper" fallbackComponent="div">
                <MithraMainLogo className="mithra-logo"/>
                {p.p.branding === 'nexo' && <img src="/logo/NExO_logo_v4_02_h60.png" alt="NExO" className="nexo-logo"/>}
            </MLink>
        </ListItemButton>
    </ListItem>
}